import {
    ITelemetryScenario,
    ITelemetryService,
    TelemetryPhaseName,
    TelemetryScenarioName,
} from '@metaos/hub-sdk';
import { logUsage, PerformanceDatapoint } from 'owa-analytics';
import { DatapointStatus } from 'owa-analytics-types';

enum AppHostTelemetryEvent {
    Usage = 'AppHost_Services_Scenario_Usage',
    Error = 'AppHost_Services_Scenario_Error',
}

export default class TelemetryService implements ITelemetryService {
    createScenario(
        name: TelemetryScenarioName,
        appId?: string,
        timestamp?: number
    ): ITelemetryScenario {
        return new TelemetryScenario(name, appId, timestamp);
    }
}

class TelemetryScenario implements ITelemetryScenario {
    private datapoint: PerformanceDatapoint;

    constructor(name: TelemetryScenarioName, appId?: string, clientTimestamp: number = Date.now()) {
        this.datapoint = new PerformanceDatapoint(AppHostTelemetryEvent.Usage);
        this.datapoint.propertyBag = { name, appId, startDate: clientTimestamp };
    }

    markPhase(name: TelemetryPhaseName): void {
        this.datapoint.addCheckmark(name);
    }

    stop(): void {
        this.datapoint.end();
    }

    fail(error?: string): void {
        this.datapoint.endWithError(DatapointStatus.ClientError, new Error(error));
        logUsage(AppHostTelemetryEvent.Error, { error });
    }
}
